import { render, staticRenderFns } from "./ResumedCard.vue?vue&type=template&id=c47ce4b6&scoped=true&"
import script from "./ResumedCard.vue?vue&type=script&lang=js&"
export * from "./ResumedCard.vue?vue&type=script&lang=js&"
import style0 from "./ResumedCard.vue?vue&type=style&index=0&id=c47ce4b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47ce4b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardText,VCardTitle,VDivider})
